import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-92">
      <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-93">
        {/* Content Column */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-94">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-gold/10 border border-gold/20 text-navy font-medium text-xs md:text-sm mb-6 md:mb-8" data-id="element-95">
            <span data-id="element-96">🏆</span>
            <span data-id="element-97">
              Sistema N°1 para Profesionales de Postparto en Argentina
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-[1.1] mb-4 md:mb-6 text-balance" data-id="element-98">
            KIT PROFESIONAL POSTPARTO™
          </h1>

          {/* Mobile-only hero image: between H1 and subtitle, at 70% width */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="lg:hidden relative w-[70%] mx-auto my-6" data-id="element-99">
            <div className="absolute inset-0 bg-gold/5 rounded-full blur-3xl transform scale-110" data-id="element-100"></div>
            <motion.img animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/6Au4zEaGyQbnmsrYg1Yaik/DPP_MOCKUPphroom.png" alt="Kit Profesional Postparto Mockup" width={800} height={800} loading="eager" decoding="async"
          // @ts-expect-error - fetchpriority is a valid HTML attribute
          fetchpriority="high" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-101" />
          </motion.div>

          <p className="text-base md:text-xl text-navy/80 mb-6 md:mb-8 leading-relaxed text-balance" data-id="element-102">
            Todo lo que necesitás para acompañar el postparto con herramientas
            reales. Evaluación, guiones, protocolos, vínculo, detección de DPP y
            mucho más. Sin improvisar nunca más.
          </p>

          <ul className="space-y-2 md:space-y-3 mb-8 md:mb-10" data-id="element-103">
            {['PDF digital', 'Acceso inmediato', 'Todas las etapas del postparto', 'Garantía 7 días'].map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.4,
            delay: 0.2 + i * 0.1
          }} className="flex items-center gap-2 md:gap-3 text-navy/90 font-medium text-sm md:text-base" data-id="element-104">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-sage" data-id="element-105" />
                <span data-id="element-106">{item}</span>
              </motion.li>)}
          </ul>

          <div className="space-y-4" data-id="element-107">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto px-6 py-3 md:px-8 md:py-4 bg-terracotta hover:bg-terracotta-600 text-white rounded-xl font-bold text-base md:text-lg shadow-lg shadow-terracotta/20 transition-colors flex items-center justify-center gap-2" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-108">
              <span data-id="element-109">💥</span>
              QUIERO MI KIT PROFESIONAL POSTPARTO
            </motion.button>

            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2 md:gap-4 text-xs md:text-sm text-navy/60 font-medium" data-id="element-110">
              <div className="flex items-center gap-1.5" data-id="element-111">
                <Lock className="w-3 h-3 md:w-4 md:h-4" data-id="element-112" />
                <span data-id="element-113">Pago 100% seguro</span>
              </div>
              <span className="hidden sm:inline text-navy/30" data-id="element-114">•</span>
              <div className="flex items-center gap-1.5 md:gap-2" data-id="element-115">
                <span data-id="element-116">Mercado Pago</span>
                <span className="text-navy/30" data-id="element-117">|</span>
                <span data-id="element-118">Tarjeta</span>
                <span className="text-navy/30" data-id="element-119">|</span>
                <span data-id="element-120">Transferencia</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Image Column — desktop only (mobile version is inlined above between H1 and subtitle) */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="hidden lg:block relative lg:ml-auto w-full lg:max-w-none" data-id="element-121">
          <div className="absolute inset-0 bg-gold/5 rounded-full blur-3xl transform scale-110" data-id="element-122"></div>
          <motion.img animate={{
          y: [0, -10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/6Au4zEaGyQbnmsrYg1Yaik/DPP_MOCKUPphroom.png" alt="Kit Profesional Postparto Mockup" width={800} height={800} loading="eager" decoding="async"
        // @ts-expect-error - fetchpriority is a valid HTML attribute
        fetchpriority="high" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-123" />
        </motion.div>
      </div>
    </section>;
}